<div class="layout-col full" appFacilityContext (facilityChange)="facility = $event">
  @if (columns$ | async; as columns) {
    <elder-table class="flex" [data]="data" (itemClick)="onClick($event)">
      <elder-data-toolbar *elderTableToolbar [canAdd]="false" [canRemove]="false" [canMore]="false">
        <ng-template elderToolbarContent="center">
          <div class="flex layout-row place-center-center gap-md pt-lg">
            @if (!hideWorkCenterSelect) {
              <mat-form-field>
                <elder-select
                  class="flex"
                  appWorkCenterSelect
                  name="workCenter"
                  autocomplete
                  [facility]="facilityId"
                  (entityChange)="workCenter = $event"
                  [allowNull]="true"
                >
                  <app-work-center-browser
                    *elderSelectionModelPopup
                    [facility]="facilityId"
                    class="flex"
                  >
                  </app-work-center-browser>
                </elder-select>
              </mat-form-field>
            }
            <mat-form-field>
              <elder-select
                appProductionListConfSelect
                [scopes]="scopes$ | async"
                name="confId"
                required
                valueAsId
                [value]="prodListConfId$ | async"
                (valueChange)="prodListConfId = $event"
                placeholder="{{ 'orders.prod.list.title' | translate }}"
              >
                <div *elderSelectValue="let value" class="layout-col text-body-medium">
                  <span>{{ value.nameI18n | i18nPick$ | async }}</span>
                  <span>{{ value.id }}</span>
                </div>
              </elder-select>
            </mat-form-field>
            @if ((mode$ | async) === ProductionListDisplayMode.PREVIEW && !hideIntervals) {
              <mat-form-field elderIntervalPickerBinding>
                <elder-interval-input [mode]="'date-range'" [(ngModel)]="scheduleInterval">
                </elder-interval-input>
                <elder-interval-picker-toggle matIconSuffix></elder-interval-picker-toggle>
              </mat-form-field>
            }
          </div>
        </ng-template>
        <ng-template elderToolbarContent="right">
          <elder-chip-list-select [data]="enabledDisplayModes" [(selection)]="modeSelection">
          </elder-chip-list-select>
          <elder-csv-export-btn
            [dataSource]="data.dataSource"
            #csvButton
            [filters]="data.filter.filters | async"
            [sorts]="data.sort.sorts | async"
            [csvSpec]="csvSpec"
          >
          </elder-csv-export-btn>
          <button mat-icon-button (click)="onPreviewProdList($event)">
            <mat-icon>picture_as_pdf</mat-icon>
          </button>
        </ng-template>
      </elder-data-toolbar>
      <!--Dynamic columns-->
      @for (column of columns; track column; let i = $index) {
        <ng-container matColumnDef="{{ column?.name }}">
          <th mat-header-cell elderNumberCell *matHeaderCellDef>
            <app-dynamic-property-header [column]="column"></app-dynamic-property-header>
          </th>
          <td mat-cell *matCellDef="let row" elderNumberCell>
            <app-dynamic-property-cell [cell]="row.cells[i]"> </app-dynamic-property-cell>
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="spacer">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef></td>
      </ng-container>
    </elder-table>
  }
</div>
